import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MessageToastService } from '../common/message-toast.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ConferenceBadgeForm, ConferenceBadgeResource, ConferenceCodesResource, ConferenceContentNmoForm, ConferenceMarkPrintedForm, ConferencePrintForm, ConferenceStatResource, ConferenceResource, IConferenceAttachment, IConferenceContentForm, IConferenceContentThesesForm, IConferenceCurrent, ConferenceFormResource, IConferenceQueryResult, PersonConferenceChangeStatusForm, IConferenceTableItem } from 'src/app/models/iconference.interface';
import { Observable, EMPTY, BehaviorSubject, of, throwError } from 'rxjs';
import { catchError, map, shareReplay, tap } from 'rxjs/operators';
import { IKeyValue } from 'src/app/models/ikeyvalue.interface';
import { IPersonOnlineReg, PersonOnlineRegForm, IPersonOnlineRegQueryResult } from 'src/app/models/iperson.interface';
import { HTTP_CONTENT_HEADERS } from 'src/app/shared/data/const.data';
import { IRenameEvent } from 'src/app/models/irenameevent.interface';
import { AnalyticsTimelineResult } from 'src/app/models/ianalytics.interface';
import { PersonConferenceExcelQueryResult, PersonConferenceStat } from 'src/app/models/iregistration.interface';
import { ConferenceContentByEmailType } from '../../models/iconference.interface';
import { AbstractTableNotMappedTableResource } from 'src/app/models/Iabstracttableitem';
import { IInfo } from 'src/app/models/ierror.interface';
import { GeoItemResource } from 'src/app/models/igeo.interface';

@Injectable({
  providedIn: 'root'
})
export class ConferenceService {

  private url = 'conferences';
  private api = environment.apiUrl;

  private _CUR_CONF_TOKEN = 'CURRENT_CONFERENCE';


  private _currentConference = new BehaviorSubject<IConferenceCurrent>(null);
  currentConference$ = this._currentConference.asObservable();

  constructor(private http: HttpClient, private msg: MessageToastService) {
    this.checkCurrentConference();
  }
  updatePersonConferenceGeo(conferenceId: number, personConferenceIds: number[], geo: GeoItemResource){
    return this.http.post(`${this.api}${this.url}/${conferenceId}/geo`, {personConferenceIds, geo})
  }
  checkCurrentConference() {
    var cur_conf = localStorage.getItem(this._CUR_CONF_TOKEN);

    const today = new Date();
    const conf = JSON.parse(cur_conf) as IConferenceCurrent;
    if (conf?.updatedAt === undefined) {
      this.setCurrentConference(null);
      return;
    }
    const diff = today.getTime() - (new Date(conf.updatedAt)).getTime();
    const hours = diff / 1000 / 60 / 60;
    if (hours > 24) {
      this.setCurrentConference(null);
      return;
    }
    this._currentConference.next(conf);

  }

  setCurrentConference(conf: IConferenceCurrent) {
    this._currentConference.next(conf);
    localStorage.setItem(this._CUR_CONF_TOKEN, JSON.stringify(conf));
  }
  resetCurrentConference() {
    this._currentConference.next(null);
    localStorage.removeItem(this._CUR_CONF_TOKEN);
  }
  get currentConference() {
    return this._currentConference.value;
  }

  getAll(): Observable<ConferenceResource[]> {
    return this.http.get<ConferenceResource[]>(`${this.api}${this.url}`).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  getCurrent(): Observable<IConferenceTableItem[]> {
    return this.http.get<IConferenceTableItem[]>(`${this.api}${this.url}/current`).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }
  getTable(filter: string): Observable<IConferenceQueryResult> {
    return this.http.get<IConferenceQueryResult>(`${this.api}${this.url}/table/?${filter}`).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  getAbstractsNotMappedTable(conferenceId: number, filter: string): Observable<AbstractTableNotMappedTableResource> {
    return this.http.get<AbstractTableNotMappedTableResource>(`${this.api}${this.url}/${conferenceId}/abstracts/notmapped?${filter}`).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  getPreliminaryTable(conferenceId: number, filter: string): Observable<IPersonOnlineRegQueryResult> {
    return this.http.get<IPersonOnlineRegQueryResult>(`${this.api}${this.url}/${conferenceId}/preliminary?${filter}`).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }
  getRegisteredTable(conferenceId: number, filter: string): Observable<PersonConferenceExcelQueryResult> {
    return this.http.get<PersonConferenceExcelQueryResult>(`${this.api}${this.url}/${conferenceId}/registered?${filter}`).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }
  getPreliminarySearchTable(conferenceId: number, fullname: string): Observable<IPersonOnlineRegQueryResult> {
    return this.http.get<IPersonOnlineRegQueryResult>(`${this.api}${this.url}/${conferenceId}/preliminary?count=10&page=1&filter[fullName]=${fullname}`).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }
  getRegisteredStat(conferenceId: number): Observable<PersonConferenceStat[]> {
    return this.http.get<PersonConferenceStat[]>(`${this.api}${this.url}/${conferenceId}/registered/stat`).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  getStat(conferenceId: number): Observable<ConferenceStatResource> {
    return this.http.get<ConferenceStatResource>(`${this.api}${this.url}/${conferenceId}/stat`).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  getStatExcel(conferenceId: number) {
    const url = `${this.api}${this.url}/${conferenceId}/stat/excel`;

    let hdrs = new HttpHeaders();
    hdrs = hdrs.set('Accept', HTTP_CONTENT_HEADERS.Excel)

    return this.http.get(url, {
      observe: 'response',
      headers: hdrs,
      responseType: 'blob'
    }).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }
  getRegisteredStats(conferenceIds: number[]): Observable<PersonConferenceStat[]> {
    return this.http.post<PersonConferenceStat[]>(`${this.api}${this.url}/registered/stat`, conferenceIds).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  getStats(conferenceIds: number[]): Observable<ConferenceStatResource> {
    return this.http.post<ConferenceStatResource>(`${this.api}${this.url}/stat`, conferenceIds).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }
  getStatsExcel(conferenceIds: number[]) {
    const url = `${this.api}${this.url}/stat/excel`;
    let hdrs = new HttpHeaders().set('Accept', HTTP_CONTENT_HEADERS.Excel);

    return this.http.post(url, conferenceIds, {
      observe: 'response',
      headers: hdrs,
      responseType: 'blob'
    }).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  getPreliminaryExport(conferenceId: number) {
    const url = `${this.api}${this.url}/${conferenceId}/preliminary/export`;

    let hdrs = new HttpHeaders();
    hdrs = hdrs.set('Accept', HTTP_CONTENT_HEADERS.Excel)

    return this.http.get(url, {
      observe: 'response',
      headers: hdrs,
      responseType: 'blob'
    }).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  getRegisteredExport(conferenceId: number) {
    const url = `${this.api}${this.url}/${conferenceId}/registered/export`;

    let hdrs = new HttpHeaders();
    hdrs = hdrs.set('Accept', HTTP_CONTENT_HEADERS.Excel)

    return this.http.get(url, {
      observe: 'response',
      headers: hdrs,
      responseType: 'blob'
    }).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  getRegisteredExportCompany(conferenceId: number) {
    const url = `${this.api}${this.url}/${conferenceId}/registered/export/company`;

    let hdrs = new HttpHeaders();
    hdrs = hdrs.set('Accept', HTTP_CONTENT_HEADERS.Excel)

    return this.http.get(url, {
      observe: 'response',
      headers: hdrs,
      responseType: 'blob'
    }).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  getPreliminaryTimeline(conferenceId: number, mode: string): Observable<AnalyticsTimelineResult[]> {
    return this.http.get<AnalyticsTimelineResult[]>(`${this.api}${this.url}/${conferenceId}/preliminary/timeline?mode=${mode}`).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );

  }

  getRegisteredTimeline(conferenceId: number, mode: string): Observable<AnalyticsTimelineResult[]> {
    return this.http.get<AnalyticsTimelineResult[]>(`${this.api}${this.url}/${conferenceId}/registered/timeline?mode=${mode}`).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );

  }

  deletePreliminary(confId: number, ids: string[]) {
    return this.http.post(`${this.api}${this.url}/${confId}/preliminary/delete`, ids).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  addPreliminary(confId: number, obj: PersonOnlineRegForm): Observable<IPersonOnlineReg> {
    return this.http.post<IPersonOnlineReg>(`${this.api}${this.url}/${confId}/preliminary`, obj).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  updatePreliminary(id: string, confId: number, obj: PersonOnlineRegForm): Observable<IPersonOnlineReg> {
    return this.http.put<IPersonOnlineReg>(`${this.api}${this.url}/${confId}/preliminary/${id}`, obj).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  setBulkStatus(confId: number, form: PersonConferenceChangeStatusForm) {
    return this.http.post(`${this.api}${this.url}/${confId}/registered/status`, form).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  autofixGeoPreliminary(confId: number) {
    return this.http.get(`${this.api}${this.url}/${confId}/preliminary/autofix`).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  replaceInReg(confId: number, obj: IRenameEvent) {
    return this.http.post(`${this.api}${this.url}/${confId}/preliminary/replace`, obj).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  getAllKeyValue(): Observable<IKeyValue[]> {
    return this.http.get<IKeyValue[]>(`${this.api}${this.url}/kv`).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  getSingle(id: number): Observable<ConferenceResource> {
    return this.http.get<ConferenceResource>(`${this.api}${this.url}/${id}`).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }



  getAlias(alias: string): Observable<ConferenceResource> {
    return this.http.get<ConferenceResource>(`${this.api}${this.url}/alias/${alias}`).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  getSingleKeyValue(id: string): Observable<IKeyValue> {
    return this.http.get<IKeyValue>(`${this.api}${this.url}/${id}/kv`).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  update(id: number, obj: ConferenceFormResource): Observable<ConferenceResource> {
    return this.http.put<ConferenceResource>(`${this.api}${this.url}/${id}`, obj).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        console.log(err);
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  updateContent(id: number, obj: IConferenceContentForm): Observable<ConferenceResource> {
    return this.http.put<ConferenceResource>(`${this.api}${this.url}/${id}/content`, obj).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        console.log(err);
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  updateContentNmo(id: number, obj: ConferenceContentNmoForm): Observable<ConferenceResource> {
    return this.http.put<ConferenceResource>(`${this.api}${this.url}/${id}/content-nmo`, obj).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        console.log(err);
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  updateContentTheses(id: number, obj: IConferenceContentThesesForm): Observable<ConferenceResource> {
    return this.http.put<ConferenceResource>(`${this.api}${this.url}/${id}/content-theses`, obj).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        console.log(err);
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  PostContentThesesByEmailType(obj: ConferenceContentByEmailType): Observable<ConferenceContentByEmailType> {
    return this.http.post<ConferenceContentByEmailType>(`${ this.api }${ this.url }/content-by-email-type`, obj)
      .pipe(shareReplay());
  }

  // Здесь id - идентификатор записи в таблице conference_abstract_email
  PutContentThesesByEmailType(id: string, alias: string, obj: ConferenceContentByEmailType): Observable<ConferenceContentByEmailType> {
    return this.http.put<ConferenceContentByEmailType>(`${ this.api }${ this.url }/${ id }/${ alias }/content-by-email-type`, obj)
      .pipe(shareReplay());
  }

  // Здесь id - идентификатор конференции
  GetContentThesesByEmailType(id: number, alias: string): Observable<ConferenceContentByEmailType> {
    return this.http.get<ConferenceContentByEmailType>(`${ this.api }${ this.url }/${ id }/${ alias }/content-by-email-type`)
      .pipe(shareReplay());
  }

  add(obj: ConferenceFormResource): Observable<ConferenceResource> {
    return this.http.post<ConferenceResource>(`${this.api}${this.url}/`, obj).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  delete(id: number) {
    return this.http.delete(`${this.api}${this.url}/${id}`).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  getValues() {
    return this.http.get(`${this.api}values`).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  uploadAttachment(conferenceId: number, formData: FormData) {
    const urlUpload = `${this.api}${this.url}/${conferenceId}/attachments`;
    return this.http.post(urlUpload, formData, { reportProgress: true, observe: 'events' });
  }

  getAttachments(conferenceId: number): Observable<IConferenceAttachment[]> {
    return this.http.get<IConferenceAttachment[]>(`${this.api}${this.url}/${conferenceId}/attachments`);
  }

  updateAttachment(conferenceId: number, id: number, obj: IConferenceAttachment) {
    return this.http.put<ConferenceResource>(`${this.api}${this.url}/${conferenceId}/attachments/${id}`, obj).pipe(
      // retryWithBackoff(1000, 3),
      catchError(err => {
        console.log(err);
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  deleteAttachment(conferenceId: number, id: number) {
    return this.http.delete(`${this.api}${this.url}/${conferenceId}/attachments/${id}`)
    // .pipe(
    //   // retryWithBackoff(1000, 3),
    //   catchError(err => {
    //     console.log(err);
    //     this.msg.errorEx(err);
    //     return EMPTY;
    //   }),
    //   shareReplay()
    // );
  }

  downloadAttachment(conferenceId: number, id: number) {
    const url = `${this.api}${this.url}/${conferenceId}/attachments/${id}`;

    let hdrs = new HttpHeaders();
    hdrs = hdrs.set('Accept', HTTP_CONTENT_HEADERS.Pdf)

    return this.http.get(url, { observe: 'response', headers: hdrs, responseType: 'blob' })
    .pipe(
      catchError((err: HttpErrorResponse) => {
        this.msg.error('Файл не найден');
        return of(null);
      })
    );
  }

  getCodes(conferenceId: number): Observable<ConferenceCodesResource> {
    return this.http.get<ConferenceCodesResource>(`${this.api}${this.url}/${conferenceId}/codes`).pipe(
      catchError(err => {
        console.log(err);
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  addCodes(conferenceId: number, codes: string[]) {
    return this.http.post<IPersonOnlineReg>(`${this.api}${this.url}/${conferenceId}/codes`, codes).pipe(
      catchError(err => {
        console.log(err);
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  assignCodes(conferenceId: number, codes: IKeyValue[]) {
    return this.http.post(`${this.api}${this.url}/${conferenceId}/codes/assign`, codes).pipe(
      catchError(err => {
        console.log(err);
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  delCodes(conferenceId: number, codes: string[]) {
    return this.http.post<IPersonOnlineReg>(`${this.api}${this.url}/${conferenceId}/codes/delete`, codes).pipe(
      catchError(err => {
        console.log(err);
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }


  importPreliminary(conferenceId: number, formData: FormData) {
    const urlUpload = `${this.api}${this.url}/${conferenceId}/import`;
    return this.http.post<any>(urlUpload, formData, { reportProgress: true, observe: 'events' });
  }
  importWebinar(conferenceId: number, formData: FormData) {
    const urlUpload = `${this.api}${this.url}/${conferenceId}/import_webinar`;
    return this.http.post<any>(urlUpload, formData, { reportProgress: true, observe: 'events' });
  }

  getBadges(conferenceId: number, form: ConferenceBadgeForm): Observable<ConferenceBadgeResource[]> {
    return this.http.post<ConferenceBadgeResource[]>(`${this.api}${this.url}/${conferenceId}/badges`, form).pipe(
      catchError(err => {
        console.log(err);
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  printBadges(conferenceId: number, form: ConferencePrintForm) {
    const url = `${this.api}${this.url}/${conferenceId}/badges/print`;

    let hdrs = new HttpHeaders();
    hdrs = hdrs.set('Accept', HTTP_CONTENT_HEADERS.Pdf)

    return this.http.post(url, form, { observe: 'response', headers: hdrs, responseType: 'blob' }).pipe(
      catchError(err => { this.msg.errorEx(err); return EMPTY; }),
      map((res) => (new Blob([res.body], { type: HTTP_CONTENT_HEADERS.Pdf }))),
      shareReplay()
    );
  }

  exportEmails(conferenceId: number) {
    const url = `${this.api}${this.url}/${conferenceId}/email`;

    let hdrs = new HttpHeaders();
    hdrs = hdrs.set('Accept', HTTP_CONTENT_HEADERS.Excel)

    return this.http.get(url, { observe: 'response', headers: hdrs, responseType: 'blob' }).pipe(
      catchError(err => { this.msg.errorEx(err); return EMPTY; }),
      map((res) => (new Blob([res.body], { type: HTTP_CONTENT_HEADERS.Excel }))),
      shareReplay()
    );
  }

  exportEmailsOnline(conferenceId: number) {
    const url = `${this.api}${this.url}/${conferenceId}/email/online`;

    let hdrs = new HttpHeaders();
    hdrs = hdrs.set('Accept', HTTP_CONTENT_HEADERS.Excel)

    return this.http.get(url, { observe: 'response', headers: hdrs, responseType: 'blob' }).pipe(
      catchError(err => { this.msg.errorEx(err); return EMPTY; }),
      map((res) => (new Blob([res.body], { type: HTTP_CONTENT_HEADERS.Excel }))),
      shareReplay()
    );
  }

  printNmoCertificates(conferenceId: number, personConferenceIds: number[]) {
    const url = `${this.api}${this.url}/${conferenceId}/nmo/print`;

    let hdrs = new HttpHeaders();
    hdrs = hdrs.set('Accept', HTTP_CONTENT_HEADERS.Pdf)

    return this.http.post(url, personConferenceIds, { observe: 'response', headers: hdrs, responseType: 'blob' }).pipe(
      catchError(err => { this.msg.errorEx(err); return EMPTY; }),
      map((res) => (new Blob([res.body], { type: HTTP_CONTENT_HEADERS.Pdf }))),
      shareReplay()
    );
  }

  sendNmoCertificates(conferenceId: number, personConferenceIds: number[]): Observable<IInfo> {
    const url = `${this.api}${this.url}/${conferenceId}/nmo/send-emails`;
    return this.http.post<IInfo>(url, personConferenceIds).pipe(
      catchError(err => { this.msg.errorEx(err); return EMPTY; }),
      map((data: IInfo) => data),
      shareReplay()
    );
  }

  markPrinted(conferenceId: number, form: ConferenceMarkPrintedForm) {
    return this.http.post<ConferenceBadgeResource>(`${this.api}${this.url}/${conferenceId}/badges/markprinted`, form).pipe(
      catchError(err => {
        console.log(err);
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }
}
